import React, { Component } from 'react';
import CountUp from 'react-countup';
import Waypoint from 'react-waypoint';
import _ from 'lodash';
import { multiLanguage } from '../../hoc';
import { BackgroundImage, ButtonGroup, Button } from '../../components';
import { mapData } from '../../data/SanctuaryClub/locations';

@multiLanguage()
export default class Locations extends Component {
  state = {
    isAppear: false,
    page: 'all'
  };
  onEnter = () => {
    this.setState({ isAppear: true });
  };

  onLeave = () => {
    this.setState({ isAppear: false });
  };
  render() {
    const { page, isAppear } = this.state;
    const { t } = this.props;
    const displayData = _.find(mapData, ['value', page]);
    return (
      <div className="section9-locations">
        <BackgroundImage image={displayData.image} size="contain" />
        <div className="run-number">
          <h2>Number of locations</h2>
          <span className="count">
            <Waypoint onEnter={this.onEnter} onLeave={this.onLeave} />
            {isAppear && <CountUp start={0} end={displayData.count} prefix="0" duration={3} formattingFn={value => _.padStart(value, 2, 0)} />}
          </span>
        </div>
        <div className="networks-button-group">
          <ButtonGroup
            value={page}
            items={mapData}
            onChange={value => this.setState({ page: value })}
            direction="horizontal"
            renderItem={({ value, name, active, onClick }) => {
              return (
                <Button
                  key={value}
                  type="secondary"
                  active={active}
                  activeStyle={{ backgroundColor: '#00a9a5' }}
                  hoverStyle={{ backgroundColor: '#00a9a5' }}
                  defaultStyle={{
                    padding: '10px 15px',
                    marginRight: '1px',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    letterSpacing: '1px'
                  }}
                  onClick={onClick}
                >
                  {t(name)}
                </Button>
              );
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Locations.js